import { Button, HStack, Spinner, Stack, Text } from '@chakra-ui/react';

type Card = {
  value?: string;
  description: string;
  fontSize?: string;
  info?: string;
  prefix?: string;
  actionTitle?: string;
  isLoading?: boolean;
  action?: () => void;
};

export const ValueCard = ({
  value,
  description,
  fontSize = '3.1rem',
  info,
  prefix,
  actionTitle,
  isLoading = false,
  action
}: Card) => {
  return (
    <Stack
      w="13.65rem"
      h="10.3rem"
      color="#fff"
      bg="#1C375C"
      align="center"
      justify="center"
      borderRadius=".6rem"
      spacing={0}
      mb=".6rem"
      px="1rem"
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <HStack h="3.25rem" spacing={0}>
            {prefix && <Text fontSize="1.4rem">{prefix}</Text>}
            <Text fontSize={fontSize}> {value}</Text>
          </HStack>
          <Text fontSize=".8rem" align="center">
            {description}
          </Text>
          <Text fontSize=".8rem" align="center">
            {info}
          </Text>
          {actionTitle && (
            <Button
              bg="#FA6B25"
              color="#fff"
              fontSize=".7rem"
              w="100%"
              h="2.1rem"
              onClick={action}
              mt="1rem !important"
              _hover={{
                opacity: '.9'
              }}
            >
              {actionTitle}
            </Button>
          )}
        </>
      )}
    </Stack>
  );
};
